import { Typography } from '@mui/material'
import Grid from '@mui/material/Grid'

import Breadcrumbs, { BreadCrumb } from '@ecm/ui/element/Breadcrumbs'
import MainContainer from '@ecm/ui/element/MainContainer'

type TopSectionProps = {
  children: React.ReactNode
  header: string
  breadCrumb: BreadCrumb[]
}

export const TopSection = ({ children, header, breadCrumb }: TopSectionProps) => (
  <MainContainer sx={{ py: '4em' }}>
    <Grid container spacing={4}>
      <Grid item md={6}>
        <Breadcrumbs breadCrumbList={breadCrumb} />
        <Typography variant="h2" component="h1" maxWidth="10em">
          {header}
        </Typography>
      </Grid>
      <Grid item md={6}>
        {children}
      </Grid>
    </Grid>
  </MainContainer>
)

export default TopSection
